import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link, useParams, Redirect } from "react-router-dom";
import Particle from "../Particle";
import ProjectEmbed from "./ProjectEmbed";
import { getProjectBySlug } from "../../data/projects";
import "../../style.css";
import "bootstrap/dist/css/bootstrap.min.css";

function ProjectDetail() {
  const { slug } = useParams();
  const project = getProjectBySlug(slug);

  if (!project) {
    return <Redirect to="/project" />;
  }

  const { detail } = project;
  const sections = detail?.sections ?? [];
  const overview = detail?.overview;
  const problem = detail?.problem;

  return (
    <Container fluid className="project-section project-detail-page">
      <Particle />
      <Container className="project-detail-inner">
        <nav className="project-detail-breadcrumb" aria-label="Breadcrumb">
          <Link to="/project">Projects</Link>
          <span className="project-detail-breadcrumb-sep" aria-hidden="true">
            /
          </span>
          <span>{project.title}</span>
        </nav>

        <header className="project-detail-header">
          <h1 className="project-detail-title">
            <strong className="purple">{project.title}</strong>
          </h1>
          {overview?.intro ? (
            <p className="project-detail-summary-intro">{overview.intro}</p>
          ) : null}
          {overview?.bullets?.length ? (
            <ul className="project-detail-summary-bullets">
              {overview.bullets.map((line) => (
                <li key={line}>{line}</li>
              ))}
            </ul>
          ) : null}
          <div className="project-detail-actions">
            <a
              className="btn btn-primary project-detail-action-btn"
              href={project.link}
              target="_blank"
              rel="noopener noreferrer"
            >
              Visit live site
            </a>
            <Link
              className="btn btn-outline-light project-detail-action-btn"
              to="/project"
            >
              All projects
            </Link>
          </div>
        </header>

        <div className="project-detail-embed-block">
          <h2 className="project-detail-section-heading">Live preview</h2>
          <div className="project-detail-embed-wrap">
            <ProjectEmbed
              src={project.link}
              className="project-detail-embed"
              openHref={project.link}
              linkLabel={`Open ${project.title} live site`}
              scaledFit
              scaledFitMode="contain"
              scaledBaseHeight={1000}
            />
          </div>
        </div>

        {problem?.qa?.length ? (
          <section
            className="project-detail-use-case"
            aria-labelledby="project-use-case-heading"
          >
            <p className="project-detail-use-case-label">Use case</p>
            <h2 id="project-use-case-heading" className="project-detail-use-case-title">
              Problem it solves
            </h2>
            <div className="project-detail-qa-list">
              {problem.qa.map((item) => (
                <div className="project-detail-qa-item" key={item.q}>
                  <h3 className="project-detail-qa-q">{item.q}</h3>
                  <p className="project-detail-qa-a">{item.a}</p>
                </div>
              ))}
            </div>
            {problem.bullets?.length ? (
              <ul className="project-detail-problem-bullets">
                {problem.bullets.map((line) => (
                  <li key={line}>{line}</li>
                ))}
              </ul>
            ) : null}
          </section>
        ) : null}

        <Row className="project-detail-sections">
          {sections.map((section) => (
            <Col key={section.id} lg={6} className="mb-4">
              <section
                className="project-detail-card"
                aria-labelledby={`project-section-${section.id}`}
              >
                <h2
                  id={`project-section-${section.id}`}
                  className="project-detail-section-title"
                >
                  {section.title}
                </h2>
                <ul className="project-detail-list">
                  {(section.items ?? []).map((item, idx) => (
                    <li key={`${section.id}-${idx}`}>{item}</li>
                  ))}
                </ul>
              </section>
            </Col>
          ))}
        </Row>
      </Container>
    </Container>
  );
}

export default ProjectDetail;
